import styled from "styled-components";
import AppBar  from "@mui/material/AppBar";
import theme from "../../../theme";
import { DialogTitle, Toolbar } from "@mui/material";
import { Form } from "formik";

export const AppBarStyled = styled(AppBar)`
  box-shadow: none;
  border-bottom: 1px solid #e0e0e0;
  background-color: ${ theme.palette.primary.main};
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    width: 100%;
`

export const ProfileCartWrapper = styled.div`
    display: flex;
    align-items: center;
   
`

export const Wrapper = styled.div``;

export const StyledToolbar = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
`;

export const ToolbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

/** Staff control, only rendered for a signed-in admin. */
export const SignOutButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 1.1rem;
  border-radius: 999px;
  cursor: pointer;
  font-family: "Jost", "Quicksand", "Helvetica Neue", Arial, sans-serif;
  font-size: 0.82rem;
  letter-spacing: 0.05em;
  color: #2e5041;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(74, 112, 97, 0.26);
  transition: background 320ms cubic-bezier(0.22, 1, 0.36, 1),
    border-color 320ms cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    background: #fff;
    border-color: #4a7061;
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  // text-align: center;
  color: #4a7061;
  font-weight: 600;
`;

export const StyledForm = styled(Form)`
  width: 100%;
  
  .MuiTextField-root {
    margin-bottom: 1.5rem;
  }
  
  .MuiButton-root {
    margin-top: 1rem;
  }
`;

